"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("el-form", {
    ref: "formData",
    staticClass: "variation-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-width": "0"
    }
  }, [_vm.isDefaultAttribute ? _c("div", {
    staticClass: "attribute-bar"
  }, [_c("div", {
    staticClass: "attribute-selects"
  }, _vm._l(_vm.attributesAndValues, function (attributesAndValue, index) {
    return _c("div", {
      key: attributesAndValue.id,
      staticClass: "attribute-select-wrap"
    }, [_c("label", {
      staticClass: "attr-label"
    }, [_vm._v(_vm._s(attributesAndValue.name))]), _c("el-select", {
      staticClass: "attr-select",
      attrs: {
        placeholder: "Select " + attributesAndValue.name,
        value: attributesAndValue.selectedValueId
      },
      on: {
        change: function ($event) {
          return _vm.handleAttribute($event, attributesAndValue.id, index);
        }
      }
    }, _vm._l(attributesAndValue.attributesValues, function (attributesValue) {
      return _c("el-option", {
        key: attributesValue.id,
        attrs: {
          label: attributesValue.name,
          value: attributesValue.id
        }
      });
    }), 1)], 1);
  }), 0), _c("div", {
    staticClass: "attribute-actions"
  }, [_c("el-button", {
    staticClass: "btn-add",
    attrs: {
      type: "primary",
      icon: "el-icon-plus"
    },
    on: {
      click: function ($event) {
        return _vm.addVariation();
      }
    }
  }, [_vm._v(" Add Variation ")]), _c("el-button", {
    staticClass: "btn-toggle-delete",
    class: {
      active: _vm.showDelete
    },
    attrs: {
      icon: "el-icon-delete",
      plain: ""
    },
    on: {
      click: function ($event) {
        _vm.showDelete = !_vm.showDelete;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.showDelete ? "Done" : "Manage") + " ")])], 1)]) : _vm._e(), _vm.productsVariations.length ? _c("div", {
    staticClass: "variations-list"
  }, [_c("el-collapse", {
    attrs: {
      accordion: ""
    },
    model: {
      value: _vm.activeCollapseIndex,
      callback: function ($$v) {
        _vm.activeCollapseIndex = $$v;
      },
      expression: "activeCollapseIndex"
    }
  }, _vm._l(_vm.productsVariations, function (variation, index) {
    return _c("el-collapse-item", {
      key: index,
      staticClass: "variation-card",
      attrs: {
        name: index
      }
    }, [_c("template", {
      slot: "title"
    }, [_c("div", {
      staticClass: "card-header"
    }, [_c("div", {
      staticClass: "card-header-left"
    }, [_vm.showDelete ? _c("el-button", {
      staticClass: "delete-btn",
      attrs: {
        type: "danger",
        size: "mini",
        circle: "",
        icon: "el-icon-delete"
      },
      on: {
        click: function ($event) {
          $event.stopPropagation();
          return _vm.handleDelete($event, index);
        }
      }
    }) : _vm._e(), _c("span", {
      staticClass: "variation-index"
    }, [_vm._v("#" + _vm._s(index + 1))]), _c("span", {
      staticClass: "variation-title"
    }, [_vm._v(" " + _vm._s(variation.modelCode || "") + " ")])], 1), _c("div", {
      staticClass: "card-header-right"
    }, [_c("span", {
      staticClass: "status-badge",
      class: variation.enabled ? "enabled" : "disabled"
    }, [_vm._v(" " + _vm._s(variation.enabled ? "Active" : "Inactive") + " ")]), variation.isDiscontinued ? _c("span", {
      staticClass: "status-badge discontinued"
    }, [_vm._v(" Discontinued ")]) : _vm._e()])])]), _c("div", {
      staticClass: "card-body-modern"
    }, [_c("div", {
      staticClass: "row-grid"
    }, [_c("div", {
      staticClass: "field"
    }, [_c("label", [_vm._v("Model Code")]), _c("el-form-item", {
      attrs: {
        prop: "productsVariations." + index + ".modelCode"
      }
    }, [_c("el-input", {
      attrs: {
        placeholder: "MC-2024-XL",
        size: "small"
      },
      model: {
        value: variation.modelCode,
        callback: function ($$v) {
          _vm.$set(variation, "modelCode", $$v);
        },
        expression: "variation.modelCode"
      }
    })], 1)], 1), _c("div", {
      staticClass: "field"
    }, [_c("label", [_vm._v("SKU")]), _c("el-form-item", {
      attrs: {
        prop: "productsVariations." + index + ".sku"
      }
    }, [_c("el-input", {
      attrs: {
        placeholder: "SKU-00123",
        size: "small"
      },
      model: {
        value: variation.sku,
        callback: function ($$v) {
          _vm.$set(variation, "sku", $$v);
        },
        expression: "variation.sku"
      }
    })], 1)], 1), _c("div", {
      staticClass: "field"
    }, [_c("label", [_vm._v("License TC")]), _c("el-form-item", {
      attrs: {
        prop: "productsVariations." + index + ".licenseTcId"
      }
    }, [_c("el-select", {
      attrs: {
        value: variation.licenseTcId && variation.licenseTcId.length ? variation.licenseTcId[0] : null,
        clearable: "",
        placeholder: "Select",
        size: "small"
      },
      on: {
        change: val => variation.licenseTcId = val ? [val] : []
      }
    }, _vm._l(_vm.licneseTcsList, function (tc) {
      return _c("el-option", {
        key: tc.id,
        attrs: {
          label: tc.name,
          value: tc.id
        }
      });
    }), 1)], 1)], 1), _c("div", {
      staticClass: "field"
    }, [_c("label", [_vm._v("Sale Price")]), _c("el-form-item", {
      attrs: {
        prop: "productsVariations." + index + ".salePrice"
      }
    }, [_c("el-input-number", {
      attrs: {
        min: 0,
        precision: 2,
        size: "small",
        "controls-position": "right"
      },
      model: {
        value: variation.salePrice,
        callback: function ($$v) {
          _vm.$set(variation, "salePrice", $$v);
        },
        expression: "variation.salePrice"
      }
    })], 1)], 1)]), _c("div", {
      staticClass: "description-row"
    }, [_c("label", [_vm._v("Short Description")]), _c("el-form-item", {
      attrs: {
        prop: "productsVariations." + index + ".description"
      }
    }, [_c("editor", {
      attrs: {
        "api-key": "no-api-key",
        init: {
          height: 250,
          plugins: ["lists link image paste help wordcount preview table | code"],
          toolbar: "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help"
        }
      },
      model: {
        value: variation.description,
        callback: function ($$v) {
          _vm.$set(variation, "description", $$v);
        },
        expression: "variation.description"
      }
    })], 1)], 1), _c("div", {
      staticClass: "toggle-row"
    }, [_c("div", {
      staticClass: "toggle-box"
    }, [_c("div", [_c("strong", [_vm._v("Enabled")]), _c("p", [_vm._v("Visible for customers")])]), _c("el-switch", {
      model: {
        value: variation.enabled,
        callback: function ($$v) {
          _vm.$set(variation, "enabled", $$v);
        },
        expression: "variation.enabled"
      }
    })], 1)])])], 2);
  }), 1)], 1) : _c("div", {
    staticClass: "empty-state"
  }, [_c("i", {
    staticClass: "el-icon-box empty-icon"
  }), _c("p", [_vm._v(" No variations yet. Select attributes and click "), _c("strong", [_vm._v("Add Variation")]), _vm._v(" to get started. ")])]), _c("div", {
    staticClass: "form-footer"
  }, [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "btn-save",
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "btn-reset",
    attrs: {
      plain: ""
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;